"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.smokeLayerCurrentTimeExtentSelector = exports.smokeLayerVisibleSelector = exports.wildfireLayerRendererSelector = exports.loadWildfireLayerRenderer = exports.smokeLayerCurrentTimeExtentChanged = exports.smokeLayerVisibleToggled = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
;
;
var slice = toolkit_1.createSlice({
    name: 'map',
    initialState: {
        wildfireLayerClassbreakRenderer: null,
        smokeLayerVisible: false,
        smokeLayerCurrentTimeExtent: []
    },
    reducers: {
        wildfireLayerRendererLoaded: function (state, action) {
            state.wildfireLayerClassbreakRenderer = action.payload;
        },
        smokeLayerVisibleToggled: function (state, action) {
            state.smokeLayerVisible = !state.smokeLayerVisible;
        },
        smokeLayerCurrentTimeExtentChanged: function (state, action) {
            state.smokeLayerCurrentTimeExtent = action.payload;
        }
    }
});
var reducer = slice.reducer, actions = slice.actions;
var wildfireLayerRendererLoaded = actions.wildfireLayerRendererLoaded;
exports.smokeLayerVisibleToggled = actions.smokeLayerVisibleToggled, exports.smokeLayerCurrentTimeExtentChanged = actions.smokeLayerCurrentTimeExtentChanged;
exports.loadWildfireLayerRenderer = function (data) { return function (dispatch, getState) {
    if (data) {
        dispatch(wildfireLayerRendererLoaded(data));
    }
}; };
exports.wildfireLayerRendererSelector = toolkit_1.createSelector(function (state) { return state.map.wildfireLayerClassbreakRenderer; }, function (wildfireLayerClassbreakRenderer) { return wildfireLayerClassbreakRenderer; });
exports.smokeLayerVisibleSelector = toolkit_1.createSelector(function (state) { return state.map.smokeLayerVisible; }, function (smokeLayerVisible) { return smokeLayerVisible; });
exports.smokeLayerCurrentTimeExtentSelector = toolkit_1.createSelector(function (state) { return state.map.smokeLayerCurrentTimeExtent; }, function (smokeLayerCurrentTimeExtent) { return smokeLayerCurrentTimeExtent; });
exports.default = reducer;
